/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import { Box3, Vector3 } from "three";
const AFRAME = window.AFRAME;

if (!AFRAME.components.panelautoresize)
    AFRAME.registerComponent("panelautoresize", {
        schema: {
            width: { type: "number", default: 0 },
            height: { type: "number", default: 0 },
            depth: { type: "number", default: 0 },
            precision: { type: "number", default: 0 },
            alert: { type: "boolean", default: false }
        },
        init: function () {
            this.scaleFactor = 1;
            this.checks = 0;
            this.maxChecks = this.data.precision ? 3 : 1;
            this.el.setAttribute("visible", false);
            this.el.setAttribute("scale", "1 1 1");

            this.tock = AFRAME.utils.throttleTick(this.tock, 100, this);
        },

        tock: function () {
            try {
                const clonedObject = this.el.object3D.clone();
                this.bbox = new Box3().setFromObject(clonedObject);
                if (!this.bbox || isNaN(this.bbox.max.x)) return;
                this.prevScaleFactor = this.scaleFactor;
                this.scaleFactor = this.getScale();
            } catch (err) {
                this.bbox = null;
                console.error("Error panelautoresize", err);
                return;
            }
            if (this.bbox && !isNaN(this.bbox.max.x) && this.scaleFactor) {
                if (this.inRange(this.scaleFactor, this.prevScaleFactor)) {
                    this.checks++;
                    if (this.checks === this.maxChecks)
                        this.el.removeAttribute("panelautoresize");
                } else {
                    this.checks = 0;
                }
            }
        },
        remove: function () {
            this.el.setAttribute("scale", {
                x: this.scaleFactor,
                y: this.scaleFactor,
                z: this.scaleFactor
            });
            this.el.setAttribute("visible", "true");
            this.el.setAttribute("panelFinished", true);
            if (this.data.alert) this.el.emit("isLoaded");
        },

        getScale: function () {
            const v = new Vector3();
            this.bbox.getSize(v);
            if (!v.x || !v.y || !v.z) return 0;

            let scales = [this.data.width / v.x, this.data.height / v.y];
            if (this.data.depth) scales = [...scales, this.data.depth / v.z];

            return +Math.min(...scales).toFixed(6);
        },
        inRange: function (x, target) {
            if (x === target) return true;
            const delta =
                (x - (target / 100) * (100 - this.data.precision)) *
                (x - (target / 100) * (100 + this.data.precision));
            return delta <= 0;
        }
    });
